import { render } from "./PlayerSummaryScoutReportForm.vue?vue&type=template&id=56ca5d76"
import script from "./PlayerSummaryScoutReportForm.vue?vue&type=script&lang=js"
export * from "./PlayerSummaryScoutReportForm.vue?vue&type=script&lang=js"

import "./PlayerSummaryScoutReportForm.vue?vue&type=style&index=0&id=56ca5d76&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__